<template>
	<div id="other" class="container-fluid">
		<div class="container">
			<navbar />

			<main class="xg-main">
				<router-view></router-view>
			</main>

			<footer>
				<p>&copy;Company 2020-2021 &emsp;&emsp;<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2021023648号-1</a></p>
			</footer>
		</div>
	</div>
</template>

<script>
	import navbar from './components/Navbar.vue'

	export default {
		components: {
			navbar
		}
	}
</script>

<style>

</style>